import { Accordion, Stack } from "react-bootstrap"
import Label from "./Label"
import React from "react"

type CAccordionProps = {
    label?       :string,
    children?    :React.ReactNode
    onExpand?    :() => void
    size?  :string | undefined
    icon?: React.ComponentType<React.SVGProps<SVGSVGElement>>
    iconSize?: number
    enabled?: boolean
}

const CAccordion:React.FC<CAccordionProps> = ({
    label="Label",
    children=null,
    onExpand=()=>{},
    size,
    icon: Icon,
    iconSize = 20,
    enabled = true,
}) => {
    const iconColor = enabled ? '#0d6efd' : '#6c757d'

    const headerContent = Icon ? (
        <Stack direction="horizontal" gap={0} style={{ alignItems: 'center'}}>
            <Icon width={iconSize} height={iconSize} style={{ color: iconColor }} />
            <Label size={size}>{label}</Label>
        </Stack>
    ) : (

        <Label padding="0 4px" size={size}>{label}</Label>
    )

    return (
        <>
        <Accordion>
            <Accordion.Item eventKey="0s">
                <Accordion.Header>{headerContent}</Accordion.Header>
                <Accordion.Body onEnter={ (_, isAppearing) => {
                    onExpand()
                }}>
                    {children}
                </Accordion.Body>
            </Accordion.Item>
        </Accordion>
        </>
    )
}

export default CAccordion